// ---------- Message for console viewers ;)  ----------
console.log(
    "%cMet online voorsprong gerealiseerd! %c\u2764 %cDoorbijters",
    "display: inline-block; border-radius: 40px 0px 0px 40px ; " +
    "border-left:1px solid #DD114A; border-top:1px solid #DD114A; border-bottom:1px solid #DD114A;" +
    "padding: 4px 0px 4px 15px; margin: 7px 0px 7px 7px;" +
    "background: #10182C ; color: white; " +
    "font-size: 12px ; ",
    "display: inline-block; border-radius: 0px ; " +
    "border-top:1px solid #DD114A; border-bottom:1px solid #DD114A;" +
    "padding: 4px 0px 4px 0px; margin: 7px 0px 7px 0px;" +
    "background: #10182C ; color: #DD114A; " +
    "font-size: 12px ; ",
    "display: inline-block ;  border-radius: 0px 40px 40px 0px ; " +
    "border-right:1px solid #DD114A; border-top:1px solid #DD114A; border-bottom:1px solid #DD114A;" +
    "padding: 4px 15px 4px 0px; margin: 7px 0px 7px 0px;" +
    "background: #10182C ; color: white; " +
    "font-size: 12px ; ",
);

// ---------- Init ----------
document.addEventListener('DOMContentLoaded', () => {
    new FontScaler();
    new ThemeController();
});
